import Image from 'next/image'
import React, { useState } from 'react'
import styled from 'styled-components'

import theme from '../../theme'
import Media from '../../utils/Media'
import { Container } from './Container'

interface Props {
  label: string
  backgroundImage: string
}

const PageHeader: React.FC<Props> = ({ label, backgroundImage }) => {
  const [loadComplete, setLoadComplete] = useState(false)

  const onLoadCompleteImage = () => {
    setLoadComplete(true)
  }

  return (
    <Wrapper $onload={loadComplete}>
      <Container>
        <Bg>
          <Image
            src={backgroundImage}
            fill
            style={{ objectFit: 'cover' }}
            alt=""
            priority={true}
            onLoad={() => {
              onLoadCompleteImage()
            }}
          />
        </Bg>
        <Title $onload={loadComplete}>
          <h1>{getEnLabel(label)}</h1>
        </Title>
        <TitleJa $onload={loadComplete}>{label}</TitleJa>
      </Container>
    </Wrapper>
  )
}

const getEnLabel = (label: string) => {
  switch (label) {
    case '会社概要':
      return 'COMPANY'
    case 'お知らせ':
      return 'NEWS'
    case '導入事例':
      return 'CASE STUDY'
    case 'プライバシーポリシー':
      return 'PRIVACY POLICY'
    case '情報セキュリティ方針':
      return 'SECURITY POLICY'
    default:
      return 'NEWS'
  }
}

const Wrapper = styled.nav<{ $onload: boolean }>`
  position: relative;
  height: 320px;
  margin-bottom: 116px;

  & > div {
    position: relative;
  }

  img {
    transform: ${(props) => (props.$onload ? 'scale(1.001)' : 'scale(1.02)')};
    transition: 0.8s ${theme.easing.easeOut} 0.2s;
    opacity: ${(props) => (props.$onload ? 1 : 0)};
  }

  h1 {
    position: relative;
    padding-top: 0.2em;
    ${theme.typography.DefShueiMincho2}
    color: #000;
    letter-spacing: 0.05em;
  }

  ${Media.mobileMiddle} {
    height: 240px;
    margin-bottom: 64px;

    h1 {
      font-size: 24px;
    }
  }
`

const Title = styled.div<{ $onload: boolean }>`
  display: flex;
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 32px;
  align-items: center;
  width: ${(props) => (props.$onload ? '50%' : '0')};
  height: 104px;
  transform: translate(0, -50%);
  transition: 0.8s ${theme.easing.easeOutExpo} 0.4s;
  border-radius: 0 99999px 99999px 0;
  background-color: #fff;

  h1 {
    ${theme.typography.FontOverpassBlack}
    transform: translate3d(0, 0, 0);
    transition: 0.4s ${theme.easing.easeOut} 0.8s;
    opacity: ${(props) => (props.$onload ? '1' : '0')};
    font-size: 48px;
    letter-spacing: 0.05em;
    line-height: 1;
  }

  ${Media.mobileMiddle} {
    left: 0;
    width: ${(props) => (props.$onload ? 'calc(100% - 40px)' : '0')};
    height: 64px;
    padding-left: 20px;

    h1 {
      font-size: 32px;
    }
  }
`

const TitleJa = styled.span<{ $onload: boolean }>`
  position: absolute;
  z-index: 1;
  top: calc(50% + 74px);
  left: 32px;
  transition: 0.4s ${theme.easing.easeOut} 1s;
  opacity: ${(props) => (props.$onload ? '1' : '0')};
  color: #1e9af3;
  font-size: 24px;
  font-weight: 700;

  ${Media.mobileMiddle} {
    top: calc(50% + 56px);
    left: 20px;
    font-size: 18px;
  }
`

const Bg = styled.div`
  position: relative;
  top: 0;
  left: 150px;
  width: calc(calc(var(--vw) * 50 + 50%) - 150px);
  height: 320px;
  overflow: hidden;
  border-radius: 16px 0 0 16px;

  ${Media.mobileMiddle} {
    left: 54px;
    width: calc(100% - 34px);
    height: 240px;
  }
`

export default PageHeader
